const MB = 1024 * 1024;

export const needsExtraction = (file) => file && (file.type.startsWith("video/") || /\.(mp4|mov|mkv|webm)$/i.test(file.name) || file.size > 30 * MB);

const COPY = {
  aac: ["Mp4OutputFormat", "m4a", "audio/mp4"],
  opus: ["WebMOutputFormat", "webm", "audio/webm"],
  vorbis: ["WebMOutputFormat", "webm", "audio/webm"],
  mp3: ["Mp3OutputFormat", "mp3", "audio/mpeg"],
};

// Pulls the audio track out of a (video) recording in the browser. Compressed audio is copied without re-encoding
// (seconds even for hour-long Meet files); uncompressed audio is re-encoded to mono Opus.
export async function extractAudio(file, onProgress) {
  const mb = await import("mediabunny");
  const input = new mb.Input({ source: new mb.BlobSource(file), formats: mb.ALL_FORMATS });
  const track = await input.getPrimaryAudioTrack();
  if (!track) throw new Error("No audio track found in this file");
  const copy = COPY[track.codec];
  if (!copy && !(await mb.canEncodeAudio("opus"))) throw new Error("This browser cannot encode Opus audio");
  const [fmt, ext, mime] = copy || COPY.opus;
  const output = new mb.Output({ format: new mb[fmt](), target: new mb.BufferTarget() });
  const conversion = await mb.Conversion.init({
    input,
    output,
    video: { discard: true },
    audio: copy ? {} : { codec: "opus", numberOfChannels: 1, sampleRate: 48000, bitrate: 32000 },
  });
  if (!conversion.isValid) throw new Error("This file's audio cannot be extracted in the browser");
  conversion.onProgress = (p) => onProgress?.(p);
  await conversion.execute();
  const base = file.name.replace(/\.[^.]+$/, "");
  return new File([output.target.buffer], `${base}.audio.${ext}`, { type: mime });
}
